import React from 'react';
import { useForm } from 'react-hook-form';
import api from '../../services/api';

const ProfessionModal = ({ onClose, onSuccess }) => {
  const { register, handleSubmit, formState: { errors } } = useForm();

  const onSubmit = async (data) => {
    const res = await api.post('/professions', data);
    onSuccess({ ...data, id: res.data.id });
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-lg p-8 w-full max-w-md">
        <h2 className="text-xl font-semibold mb-4">Ajouter une profession</h2>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">Profession *</label>
            <input {...register('profession', { required: true })} className="block w-full rounded-lg border border-gray-300 px-3 py-2" />
            {errors.profession && <span className="text-red-500 text-xs mt-1">Champ obligatoire</span>}
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">Description</label>
            <input {...register('description')} className="block w-full rounded-lg border border-gray-300 px-3 py-2" />
          </div>
          <div className="flex justify-end space-x-2">
            <button type="button" className="px-4 py-2 bg-gray-200 rounded-lg" onClick={onClose}>Annuler</button>
            <button type="submit" className="px-4 py-2 bg-primary-600 text-white rounded-lg">Enregistrer</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ProfessionModal;
